import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import moment from 'moment';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { Highlights } from './Highlights';
import * as _ from 'underscore';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, Validators } from '@angular/forms';
import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';
import { EmailCampaignService } from 'src/app/email-campaign/email-campaign.service';
import { CampaignService } from 'src/app/_services/campaign.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { ArchiveCandidateModalComponent } from '../archive-candidate-modal/archive-candidate-modal.component';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { BulkEmailCampaignComponent } from '../bulk-email-campaign/bulk-email-campaign.component';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { Router } from '@angular/router';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
declare const clevertap;

type FFHUnicornTierOne = {
  fortune500: string[];
  unicorn: string[];
  tierOneSchools: string[];
};
@Component({
    selector: 'app-ai-sourcing-profile-card',
    templateUrl: './ai-sourcing-profile-card.component.html',
    styleUrls: ['./ai-sourcing-profile-card.component.scss'],
    standalone: false
})
export class AiSourcingProfileCardComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() calledfrompage: string;
  @Input() i: any;
  @Input() showProgressBar: boolean;
  @Input() selectedCandididate: any;

  primaryCompanyInformation: any;
  currentCompany: string;
  currentSchool: any;
  currentJobTitle: string;
  currentTenure: string;
  currentexplocation: string;
  currentLocation: string;
  currentCompanyInformation: any = {};
  totalTenure: string;
  highlightsPillData = new Highlights();
  @Input() index: number;
  @Output() childEvents = new EventEmitter<{ action: string, data: any, status?: string }>();
  successMessage: string;
  errorMessage: string;
  projectNumber: string

  /** Handle for expand screening criteria */
  expandedStates: boolean[] = [];
  allExpanded = false;
  campaign_input = new UntypedFormControl(null, [Validators.required]);
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  isLoadingEmailCampaignApi: boolean = false;
  selectedCampaign: any;
  emailFoundCount: number;
  campaignList: any;
  @Output() refreshCurrentView: EventEmitter<any> = new EventEmitter();

  archiveModal: boolean = false
  highlights: MatchHighlights;
  subscriptions: Array<Subscription> = [];
  totalCandidateSelected: Array<Object> = [];

  highlightsList: any[] = [];
  showloadingScreening :boolean=false;
  @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
  campaignName: string = '';

  constructor(private personSearchService: PersonSearchService, public aiSourcingService: AiSourcingService, private modalService: NgbModal,
    private emailCampaignService: CampaignService, private _localStorageService: LocalStorageService, private candidateservice: CandidateService,
        private aiSourcingHandlerService: AiSourcingHandlerService, private router: Router, private atssesumescreenservice:AtsResumeScreenService
  ) {}

  ngOnInit() {
    // const getCandidateSubscription = this.aiSourcingService.getCandidateEvent.subscribe((res: any) => {
    //   this.totalCandidateSelected = res?.length || 0;
    // });
    // this.subscriptions.push(getCandidateSubscription);

    this.initExpandedStates();
    this.projectNumber = window.location.pathname?.split('/')[4];

    if (this.calledfrompage != 'resume-screen') {
      this.setHighlightsData();
      this.highlightsList = this.getTierOneCompanyAndSchoolHilights(this.data?.curatedtalentpooltags);
      this.totalTenure = this.getFormattedTenure(this.data.totaltenure);
    };

    this.currentLocation = this.data?.location_name;


      this.data.experience = this.data?.experience?.map(obj => {
        const startDate = obj.start_date ? moment(obj.start_date) : null;
        const endDate = moment(obj.end_date || new Date());
        const totalTenure = endDate.diff(startDate, 'years', true);
        obj.totaltenure = this.getFormattedTenure(totalTenure);
        if (obj.is_primary === true || obj.is_primary === 'true') {
          if (obj) {
            this.primaryCompanyInformation = obj.company
            if (this.primaryCompanyInformation && this.primaryCompanyInformation['location']) {
              this.primaryCompanyInformation['location'] = obj?.company?.location?.name ? obj?.company?.location?.name : obj.location_names[0]
            }
            if (obj.company && obj.company.name) {
              this.currentCompany = obj.company.name;
            }
            if (obj.title && obj.title.name) {
              this.currentJobTitle = obj.title.name;
            }
            if (obj.totaltenure) {
              this.currentTenure = obj.totaltenure;
            }
            if (obj.location_names.length > 0) {
              this.currentexplocation = obj.location_names[0];
            }

            // if(this.currentLocation == null){
            //   if(obj && obj.company && obj.company.location && obj.company.location.name){
            //     this.currentLocation = obj.company.location.name;
            //   }
            // }
          }
        }
        return obj;
      })

    if (!this.currentCompany && !this.currentJobTitle) {
      const clonedExperience = this.data.experience.filter((obj) => obj.is_primary != true && obj.is_primary != 'true');
      if (clonedExperience && clonedExperience.length) {
        if (this.currentJobTitle == null) {
          this.currentJobTitle = clonedExperience[0].title.name;
        }
        if (this.currentCompany == null) {
          this.currentCompany = clonedExperience[0].company.name;
        }
      }
    };

    const clonedEducation = this.data?.education?.length ? this.data?.education[0] : null;
    if (clonedEducation) {
      this.currentSchool = clonedEducation?.school?.name
    };

  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  };

  /** Method to handle initially state behaviour */
  initExpandedStates() {
    const criteriaList = this.data?.screening_response?.screening_criteria || [];
    if (criteriaList.length > 0 && this.expandedStates.length !== criteriaList.length) {
      this.expandedStates = new Array(criteriaList.length).fill(false);
      this.allExpanded = false;
    }
  };

  /** Method to handle expand and collapse behaviour */
  toggleCollapse(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
    this.allExpanded = this.expandedStates.every(state => state);
  };

  /** Method to handle Expand All behaviour */
  expandAll() {
    this.expandedStates = this.expandedStates.map(() => true);
    this.allExpanded = true;
  };

  /** Method to handle collapse All behaviour */
  collapseAll() {
    this.expandedStates = this.expandedStates.map(() => false);
    this.allExpanded = false;
  };

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  getCompanyInfo(type: string, data: any, event) {
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    // this.currentCompanyInformation = {}
    let companyData;
    let pastCompanyData = data?.company

    if (type == 'main') {
      if (!this.primaryCompanyInformation?.website) {
        return;
      }
      if (this.primaryCompanyInformation?.id || this.primaryCompanyInformation?.name) {
        companyData = [
          {
            ...((this.primaryCompanyInformation?.id) && { id: this.primaryCompanyInformation?.id }),
            ...((this.primaryCompanyInformation?.name) && { name: this.primaryCompanyInformation?.name })
          }
        ]
      }

    } else if (type == 'past') {
      if (!pastCompanyData?.website) {
        return;
      }
      companyData = [
        {
          ...((pastCompanyData?.id) && { id: pastCompanyData?.id }),
          ...((pastCompanyData?.name) && { name: pastCompanyData?.name })
        }
      ]
    }
    this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if (res.status == 'success' && res.data) {
        let companyDetails = res.data[0]
        if (type != 'main') {
          this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website
          this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData?.name
          this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
          this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location?.name
          this.currentCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : pastCompanyData?.size
          this.currentCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : pastCompanyData?.linkedin_url
          this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
          this.currentCompanyInformation['tags'] = companyDetails.tags
          this.currentCompanyInformation['id'] = companyDetails.id
          this.currentCompanyInformation['key_id'] = companyDetails.id
          this.currentCompanyInformation['facebook_url'] = companyDetails?.facebook_url ? companyDetails?.facebook_url : pastCompanyData?.facebook_url
          this.currentCompanyInformation['twitter_url'] = companyDetails?.twitter_url ? companyDetails?.twitter_url : pastCompanyData?.twitter_url

        }
        if (type == 'main') {
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['tags'] = companyDetails.tags
          this.primaryCompanyInformation['key_id'] = companyDetails.id

        }
        //loadn[0].style.display = 'block'

      }
    });
  }

  private setHighlightsData() {
    this.highlightsPillData.setTechie(this.isCandidateTechie(this.data));
    this.highlightsPillData.setTalentIndustries(this.getTalentIndustries(this.data?.experience));
    const extraHighlightsDetails = this.getFFHUnicornAndTierOne(this.data?.curatedtalentpooltags);
    this.highlightsPillData.setUnicornCompanies(extraHighlightsDetails.unicorn);
    this.highlightsPillData.setFortuneFH(extraHighlightsDetails.fortune500);
    this.highlightsPillData.setTierOneSchools(extraHighlightsDetails.tierOneSchools);
  }

  isCandidateTechie(data: any): boolean {
    let isTechie = false;
    if (!!data.profiles && !!data.profiles.length) {
      isTechie = data.profiles.some(item => item.network == "stackoverflow");
    }
    isTechie = isTechie || !!data.github_url;
    return isTechie;
  }

  getTalentIndustries(experiences: any[]): any {

    let industries: { name: string; exp: {}; }[] = [];

    experiences.forEach(el => {
      if (!!el?.company?.industry)
        industries.push({
          name: el?.company?.industry,
          exp: this.getExperience(el)
        });
    });
    // industries = _.uniq(industries, x => x.name);

    let data = this.getUniqueIndustries(industries)
    return data;
  }

  getUniqueIndustries(industries) {
    const uniqueData = this.uniqueExperience(industries);
    return uniqueData;

  }


  uniqueExperience(data) {
    const result = {};

    for (const item of data) {
      const key = `${item.name}`;

      if (result[key]) {
        if (item.exp.start_date == result[key].exp.start_date) {
          result[key].exp.year = item.exp.year;
          result[key].exp.month = item.exp.month;
        } else {
          result[key].exp.year += item.exp.year;
          result[key].exp.month += item.exp.month;

          while (result[key].exp.month >= 12) {
            result[key].exp.year += 1;
            result[key].exp.month -= 12;
          }
        }
      } else {
        result[key] = {
          name: item.name,
          exp: { year: item.exp.year, month: item.exp.month, start_date: item.exp.start_date }
        };
      }
    }

    const uniqueAggregatedData = Object.values(result);
    return uniqueAggregatedData;
  }

  getExperience(obj: any) {

    let exp = {}

    if (obj.start_date && obj.end_date !== null && obj.start_date !== null) {

      let startDate = obj.start_date;
      let endDate = obj.end_date;

      const startDateArray = startDate.split("-");
      const endDateArray = endDate.split("-");

      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);

      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }

      exp = { year: yearDiff, month: monthDiff, start_date: startDate }

    } else {

      if (obj.start_date !== null) {
        let startDate = obj.start_date;
        const formattedDate = new Date();
        const year = formattedDate.getFullYear();
        const month = formattedDate.getMonth() + 1;
        const currentDate = `${year}-${month}`;

        const startDateArray = startDate.split("-");
        const endDateArray = currentDate.split("-");

        const startYear = parseInt(startDateArray[0], 10);
        const startMonth = parseInt(startDateArray[1], 10);
        const endYear = parseInt(endDateArray[0], 10);
        const endMonth = parseInt(endDateArray[1], 10);

        let yearDiff = endYear - startYear;
        let monthDiff = endMonth - startMonth;

        if (monthDiff < 0) {
          yearDiff--;
          monthDiff += 12;
        }
        exp = { year: yearDiff, month: monthDiff, start_date: startDate }
      }
    }

    return exp;
  }

  /**
   * @returns An object with list of fortune five hundred, unicorn experience, and tier 1 school experience details.
   *
   */
  private getFFHUnicornAndTierOne(curatedtalentpooltags): FFHUnicornTierOne {
    const res = {
      fortune500: [],
      unicorn: [],
      tierOneSchools: []
    };
    if (!curatedtalentpooltags)
      return res;
    for (let el of curatedtalentpooltags) {
      if (el?.type === "experience" && el?.displayname?.toLowerCase() === "fortune-500" && !!el?.name) { res.fortune500.push(el?.name); }
      else if (el?.type === "experience" && el?.displayname?.toLowerCase() === "unicorn" && !!el?.name) { res.unicorn.push(el?.name); }
      else if (el?.type === "education" && el?.displayname?.toLowerCase() === "tier-1 school" && !!el?.name) { res.tierOneSchools.push(el?.name); }
    }
    res.fortune500 = _.uniq(res.fortune500);
    res.unicorn = _.uniq(res.unicorn);
    res.tierOneSchools = _.uniq(res.tierOneSchools);
    return res;
  }

  // openCandidateSlider(data, currentIndex) {
  //   this.currentCandidate = data;
  //   this.currentIndex = currentIndex
  //   this.showCandidate = true;
  //   document.getElementById("quickView").style.width = "55%";
  //   document.getElementById("quickView").style.right = "0";
  //   document.getElementById("overlay").style.display = "block";
  //   const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
  //   //loadn[0].style.display = 'none'
  // }

  /**
* Handles all child events
* @param action type of action
* @param event Evenet
*/
  handleChildEvents(action: string, event?: Event, type: any = null, contactIndex: any = null) {
    if(this.data?.screening_response?.overallscore == null) return
    let eventData = {
      action: action,
      data: {
        ...this.data,
        highlightsPillData: this.highlightsPillData,
        selected: event ? (event.target as HTMLInputElement).checked : this.data.selected,
        currentIndex: this.index,
        calledfrompage: this.calledfrompage
      }
    }
    if (type == 'show-contact') {
      eventData['type'] = 'show-contact'
    } else if (type == 'show-activity') {
      eventData['type'] = 'show-activity'
    } else if (type == 'show-skills') {
      eventData['type'] = 'show-skills'
    }
    this.childEvents.emit(eventData)
  }
  receiveData(message: string, data?: any, status?: any) {
    if (message == 'success') {
      this.archiveModal = false
      this.successMessage = 'Candidate successfully archived';
      setTimeout(() => {
        this.successMessage = '';
      }, 5000);
      if (this.calledfrompage == 'reviewpage') {
        this.childEvents.emit({ action: "success", data: data, status: 'archive' });
      } else if (this.calledfrompage == 'shortlistpage') {
        this.childEvents.emit({ action: "success", data: data, status: 'archive' });
      }
   /**
            * Click on To Archive button
          */
         const archiveParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.calledfrompage,
          "ElasticId": this.data?.id

        }
        clevertap.event.push("Autopilot-Archive Candidate",archiveParams);

    } else if (message == 'closemodal') {
      this.modalService.dismissAll()
      this.archiveModal = false
    } else {
      this.errorMessage = 'Error occurred while archiving candidate';
      setTimeout(() => {
        this.errorMessage = '';
      }, 5000);
    }
  }
  changeCandidateStatus(data, status) {
    if (status == 'archive') {
      this.archiveModal = true

      //  const modalRef = this.modalService.open(ArchiveCandidateModalComponent, { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false });
      //  modalRef.componentInstance.data = data;
      //   modalRef.componentInstance.projectNumber = this.projectNumber;
      //   modalRef.componentInstance.passEntry.subscribe((res: any) => {
      //     if (res === "success") {
      //       this.successMessage = 'Candidate successfully archived';
      //       setTimeout(() => {
      //         this.successMessage = '';
      //       }, 5000);
      //       if(this.calledfrompage == 'reviewpage'){
      //         this.childEvents.emit({action:"success", data: data, status:'archive' });
      //       } else if(this.calledfrompage == 'shortlistpage'){
      //         this.childEvents.emit({action:"success", data: data, status:'archive' });

      //       }
      //     } else {
      //       this.errorMessage = 'Error occurred while archiving candidate';
      //       setTimeout(() => {
      //         this.errorMessage = '';
      //       }, 5000);
      //     }
      //   });

    } else if (status == 'shortlisted') {
      const payload = {
        projectnumber: this.projectNumber,
        status: status,
        elasticids: [data.id],
      }

      this.aiSourcingService.changeCandidateStatus(payload).subscribe((res: any) => {
        if (res.status === 'success') {
          this.successMessage = 'Candidate successfully shortlisted';
          setTimeout(() => {
            this.successMessage = '';
          }, 5000);
          if (this.calledfrompage == 'reviewpage') {
            this.childEvents.emit({ action: "success", data: data, status: 'shortlist' });
          } else if (this.calledfrompage == 'archivepage') {
            this.childEvents.emit({ action: "success", data: data, status: 'shortlist' });

          }
          this.childEvents.emit({ action: "success", data: data });
            /**
            * Click on To Shortlist button
          */
         const shortlistParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.calledfrompage,
          "ElasticId": data.id

        }
        clevertap.event.push("Autopilot-Shortlist Candidate",shortlistParams);


        } else {
          this.errorMessage = 'Error occurred while changing candidate status';
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
        }
      }, (err)=>{
        if(err.status === 422){
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
        }
      })
    }
  }

  openAddToEmailCampaign() {
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  addToEmailCampaign() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if (this.campaign_input.valid && this.selectedCampaign) {
      const campaign_id = this.selectedCampaign.campaign_id;
      let unsubscribedCandidateCount = 0;
      let payloadArray = (Array.isArray(this.data) ? this.data : [this.data]).map(x => {
        if (x?.is_unsubscribed) {
          unsubscribedCandidateCount++;
          return;
        }
        return {
          firstname: x.first_name,
          target_name: x.full_name,
          target_id: null,
          target_meta: JSON.stringify({
            "candidatenumber": x.candidatenumber && x.candidatenumber.length ? x.candidatenumber : null,
            "elastic_id": x.id,
            "title": x.job_title,
          }),

          //elastic || else send 0
          target_email: x.existingContactDetails && x.existingContactDetails.length ?
            this.extractPreferredEmail(x.existingContactDetails) : null,

          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString(),
          projectnumber: this.projectNumber,
        };
      }).filter(Boolean);
      const updatedPayloadArray = payloadArray.filter(x => x);
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );

      if (unsubscribedCandidateCount > 0 && updatedPayloadArray.length === 0) {
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }
      const payload = {
        projectnumber: this.projectNumber,
        elasticids: [this.data.id]
      }
      this.campaignName = this.campaign_input.value;

        if (this.data.existingContactDetails.length && this.data.existingContactDetails.some(x => x.type === 'email')) {
        this.aiSourcingService.aiSourcingMigrate(payload).subscribe((res: any) => {
        const newMeta = JSON.parse(updatedPayloadArray[0].target_meta);
        newMeta.candidatenumber = res.data[0].candidatenumber;
        updatedPayloadArray[0].target_meta = JSON.stringify(newMeta);
          this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
                            this.isLoadingEmailCampaignApi = false;

            if (res.status == 'success') {
              if (res.data && res.data.length) {
                this.refreshCurrentView.emit(this.data);
                this.addEmailCampaignActivity(res.data);
                this.showEmailCampaignCount();
                this.closeActiveModal();
                const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
              } else {
                this.closeActiveModal();
                this.toastmessage("Candidate already present in selected campaign", 'error');
              }
            } else {
              this.closeActiveModal()
              this.toastmessage("candidate addition failed", "error");
            }
        /**
          * Click on To add to EmailCampaign button
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.calledfrompage,
          "ElasticId": this.data.id

        }
        clevertap.event.push("Autopilot-Add To Email Campaign Candidate",emailCampaignParams);

          }, (error: HttpErrorResponse) => {
                  this.isLoadingEmailCampaignApi = false;
                  if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                    const remainingTargets = error.error.remainingTargets;
                    this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                  } else {
                    this.toastmessage("Something went wrong", "error");
                  }
                  this.closeActiveModal();
                });
        })
        } else {
          Promise.all(updatedPayloadArray.map(async (x: any) => {
            x.target_email = await this.getContactDetails(this.data.id, this.selectedCampaign['email_pref']);
            return x;
          })).then((newPayload) => {
            this.aiSourcingService.aiSourcingMigrate(payload).subscribe((res: any) => {
        const newMeta = updatedPayloadArray?.length ? JSON.parse(updatedPayloadArray[0]?.target_meta ): {};
        newMeta.candidatenumber = res.data[0].candidatenumber;
        updatedPayloadArray[0].target_meta = JSON.stringify(newMeta);
            if (newPayload[0].target_email) {
              this.emailCampaignService.createTarget(campaign_id, newPayload).subscribe((res: any) => {
                this.isLoadingEmailCampaignApi = false;
                if (res.status == 'success') {
                  if (res.data && res.data.length) {

                    this.refreshCurrentView.emit(this.data);
                    this.addEmailCampaignActivity(res.data);
                    this.showEmailCampaignCount()
                    this.closeActiveModal();
                    const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
                  } else {
                    this.closeActiveModal()
                    this.toastmessage("Candidate already present in selected campaign", 'error')
                  }
                } else {
                  this.closeActiveModal()
                  this.toastmessage("candidate addition failed", "error");
                }

                 /**
          * Click on To add to EmailCampaign button
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.calledfrompage,
          "ElasticId": this.data.id

        }
        clevertap.event.push("Autopilot-Add To Email Campaign Candidate",emailCampaignParams);
              },
            (error: HttpErrorResponse) => {
                  this.isLoadingEmailCampaignApi = false;
                  if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                    const remainingTargets = error.error.remainingTargets;
                    this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                  } else {
                    this.toastmessage("Something went wrong", "error");
                  }
                  this.closeActiveModal();
                })
            } else {
              this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
                                this.isLoadingEmailCampaignApi = false;

                if (res.status == 'success') {
                  if (res.data && res.data.length) {
                    this.refreshCurrentView.emit(this.data);
                    this.addEmailCampaignActivity(res.data);
                    this.closeActiveModal()

                    this.showEmailCampaignCount();
                    this.openEmailCampaignModal(campaign_id, newMeta.candidatenumber);
                  } else {
                    this.closeActiveModal()

                    this.toastmessage("Candidate already present in selected campaign", 'error')
                  }
                } else {
                  this.closeActiveModal()
                  this.toastmessage("candidate addition failed", "error");

                }
                 /**
          * Click on To add to EmailCampaign button
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": this.calledfrompage,
          "ElasticId": this.data.id

        }
        clevertap.event.push("Autopilot-Add To Email Campaign Candidate",emailCampaignParams);
                }, (error: HttpErrorResponse) => {
                  this.isLoadingEmailCampaignApi = false;
                  if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                    const remainingTargets = error.error.remainingTargets;
                    this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                  } else {
                    this.toastmessage("Something went wrong", "error");
                  }
                  this.closeActiveModal();
                });
            }
          })

          })
        }
         }
  }

  extractPreferredEmail(details) {
    let emailPref = this.selectedCampaign['email_pref'];
    let personalPref_email = [];
    let professionalPref_email = [];
    let targetEmailFound = '';
    const existingContactDetails = details?.filter(x => x.type === 'email');
    if (existingContactDetails && existingContactDetails.length) {

      personalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'personal')
      professionalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'professional')

      switch (emailPref) {
        case 1: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : '';
          break;
        case 2: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
          break;
        case 3: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
          break;
        case 4: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : personalPref_email.length ? personalPref_email[0].contactdetail : '';
          break;
      }
    }
    return targetEmailFound;
  }

  closeActiveModal() {
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.modalService.dismissAll()
  }
  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  openDetailsModal(campaign_id, payload, emailsFound, total_target) {
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }


  showEmailCampaignCount() {
    if (this.data && this.data.emailcampaigncount >= 1) {
      this.data.emailcampaigncount = this.data.emailcampaigncount + 1
    } else {
      this.data.emailcampaigncount = 1
    }
  }

  getContactDetails(elasticid, emailPref) {
    return new Promise((resolve, reject) => {
      // let data = {
      //   "usernumber": this._localStorageService.getItem('usernumber'),
      //   "candidatenumber": candidateid,
      // };

      this.aiSourcingService.contactReveal(this.projectNumber, elasticid).subscribe(
        (res: any) => {
          if (res.status === 'success') {

            let personalPref_email = [];
            let professionalPref_email = [];
            let targetEmailFound = '';
            const existingContactDetails = res?.data.filter(x => x.type === 'email');
            if (existingContactDetails && existingContactDetails.length) {

              personalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'personal')
              professionalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'professional')

              switch (emailPref) {
                case 1: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : '';
                  break;
                case 2: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
                  break;
                case 3: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
                  break;
                case 4: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : personalPref_email.length ? personalPref_email[0].contactdetail : '';
                  break;
              }
            }
            if (targetEmailFound) {
              resolve(targetEmailFound);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }

  onTypeAheadSearch(event: string): void {
    const query = event;
    this.emailCampaignService.getCampaigns({ campaign_name: query, created_by: this._localStorageService.getItem('userdata').userid, 'status[]': [1, 2] }).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }


  /**
   * Method to return match category
   * @param matchcategory
   * @returns
   */
  showMatchScore(matchcategory: string) {
    let match = '';

    if (matchcategory == 'EXCELLENT') {
      match = 'Excellent Match';
    } else if (matchcategory == 'GOOD') {
      match = 'Good Match';
    } else if (matchcategory == 'POTENTIAL') {
      match = 'Potential Match';
    } else if (matchcategory == 'NOT_A_MATCH') {
      match = 'Not a Match';
    }

    return match;
  };

  openEmailCampaignModal(campaign_id, candidateid) {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(BulkEmailCampaignComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.candidateNumber =  candidateid;
  }

  addEmailCampaignActivity(data) {
    const payload = {
      "projectnumber": this.projectNumber,
      "action": "addtoemailcampaign",
      "elasticids": data.map(x => x.target_meta ? JSON.parse(x.target_meta).elastic_id : null),
      "activitydata": {
        "campaignname": this.selectedCampaign.campaign_name,
      }
    }

    this.aiSourcingService.aiSourcingEmailCampaignActivity(payload).subscribe((res: any) => {
      if (res.status === 'success') {
        console.log('Email campaign activity tracked successfully');
      } else {
        console.error('Error occurred while tracking email campaign activity');
      }
    });
  }

/**
 *
 * @param curatedtalentpooltags
 * @returns
 */
  private getTierOneCompanyAndSchoolHilights(curatedtalentpooltags: any[]) {
    const highlightsFormatedData: any[] = [];
    const grouped: Record<string, any> = {};

    if (this.highlightsPillData.fetchTalentIndustries && this.highlightsPillData.fetchTalentIndustries.length) {
      grouped['fetchTalentIndustries'] = { label: "Multi-Industry", value: this.highlightsPillData.fetchTalentIndustries, color: "blue", imageName: "multi-industry" }
    }

    if (this.highlightsPillData.fetchUnicornCompanies && this.highlightsPillData.fetchUnicornCompanies.length) {
      grouped['fetchUnicornCompanies'] = { label: "Unicorn Experience", value: this.highlightsPillData.fetchUnicornCompanies, color: "yellow", imageName: "unicorn-experience" }
    }

    if (this.highlightsPillData?.isTechie) {
      grouped['isTechie'] = { label: "Techie", value: this.highlightsPillData.isTechie, color: "green", imageName: "techie" }
    }

    if (this.data?.currentjob_internal_movement || this.data?.progression_within_pastcompany) {
      grouped['PromotionTrack'] = { label: "Promotion Track", value: { currentjob_internal_movement: this.data?.currentjob_internal_movement, progression_within_pastcompany: this.data?.progression_within_pastcompany }, color: "yellow", imageName: "promotion-track" }
    }

    if (this.highlights?.locationNames) {
      grouped['SameLocation'] = { label: "Same Location", value: this.highlights?.locationNames, color: "green", imageName: "same-location" }
    }

    if (this.highlights?.regionname) {
      grouped['NearbyLocation'] = { label: "Nearby Location", value: this.highlights?.regionname, color: "green", imageName: "same-location" }
    }

    if (this.highlights?.titles) {
      grouped['RoleCompatibility'] = { label: "Role Compatibility", value: this.highlights?.titles, color: "title", imageName: "role-compatibility" }
    }

    if (this.highlights?.totalTenure) {
      grouped['YearsOfExperience'] = { label: "Years of Experience", value: this.highlights?.totalTenure, color: "yearsofexp", imageName: "years-of-experience" }
    }

    if (this.highlights?.companySizes) {
      grouped['CompanySize'] = { label: "Company Size", value: this.highlights?.companySizes, color: "pink", imageName: "company-size" }
    }

    if (this.highlights?.skills) {
      grouped['SkillsMatched'] = { label: "Skills Matched", value: this.highlights?.skills, color: "skills", imageName: "skills-matched" }
    }

    const displayNameConfig: any = {
      "maang": { label: "MAANG", color: "maang", imageName: "maang" },
      "dax 40": { label: "DAX 40", color: "dax", imageName: "dax40" },
      "nasdaq 100": { label: "NASDAQ 100", color: "nasdaq", imageName: "nasdaq100" },
      "nifty 50 / sensex": { label: "Nifty 50 / Sensex", color: "nifty", imageName: "nifty50" },
      "fortune-500 us": { label: "Fortune Global 500", color: "fortuneGlobal", imageName: "fortuneglobal500" },
      "s&p 500": { label: "S&P 500", color: "sp", imageName: "sp500" },
      "big four": { label: "Big 4", color: "bigfour", imageName: "big4" },
      "dow 30": { label: "DOW 30", color: "dow", imageName: "dow30" },
      "fortune-500": { label: "Fortune 500", color: "fortune", imageName: "fortune500" },
      "big oil": { label: "Big Oil", color: "bigoil", imageName: "bigoil" },
      "ftse 100": { label: "FTSE 100", color: "ftse", imageName: "ftse100" },
      "u15 group (canada)": { label: "U15 Group (Canada)", color: "u15group", imageName: "u15" },
      "batx": { label: "BATX", color: "batx", imageName: "batx" },

      "tier-1 school": { label: "Tier-1 School", color: "teal", imageName: "tier1school" },
      "c9 league (china)": { label: "C9 League (China)", color: "c9League", imageName: "c9" },
      "ivy league (usa)": { label: "Ivy League (USA)", color: "ivy", imageName: "ivy" },
      "group of eight (australia)": { label: "Group of Eight (Australia)", color: "navy", imageName: "go8" },
      "russell group (uk)": { label: "Russell Group (UK)", color: "groupOfEight", imageName: "russell" },
    };



    for (let el of curatedtalentpooltags) {
      if (!el?.displayname || !el?.name) continue;

      const key = el.displayname.toLowerCase().trim();
      const config = displayNameConfig[key];
      if (!config) continue;

      if (!grouped[key]) {
        grouped[key] = {
          id: Object.keys(grouped).length + 1,
          label: config.label,
          value: [],
          color: config.color,
          imageName: config.imageName
        };
      }

      if (!grouped[key].value.includes(el.name)) {
        grouped[key].value.push(el.name);
      }
    }

    return Object.values(grouped);
  }


  rerunCandidate(data: any) {
    let eventData = {
      jobId: data.ats_job_id,
      candidateNumber: data.candidatenumber
    }
    this.showloadingScreening = true;
    this.atssesumescreenservice.reRunScreening(eventData).subscribe((res: any) => {
      if (res && res.body && res.body?.status == 'success') {
        this.showloadingScreening = false;
        this.atssesumescreenservice.emitCandidateReRunEvent(res.body);
      } else {
        this.showloadingScreening = false;
      }
    }, (err) => {
      this.showloadingScreening = false;
    })
  }

  redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
  }
}
